import Highcharts from 'highcharts';
import highchartsExportingInit from 'highcharts/modules/exporting';
import highchartsExportDataInit from 'highcharts/modules/export-data';
import 'unpoly';

highchartsExportingInit(Highcharts);
highchartsExportDataInit(Highcharts);

const up = window.up; // Unpoly's global

up.compiler('#stations-growth-unpoly-wrapper', (wrapper) => {
  const stationCounts = wrapper.querySelector('#station-counts');
  const chartData = up.data(stationCounts);

  // Datasets for chart
  const level2AvailableDataset = chartData.dataL2Available;
  const dcAvailableDataset = chartData.dataDcAvailable;
  const l2TempUnavailableDataset = chartData.dataL2TmpUnavailable;
  const dcTempUnavailableDataset = chartData.dataDcTmpUnavailable;

  const toolTipTotal = `<span style="font-size:0.75rem;"><b>${chartData.toolTipTotal}{point.total:,.0f}</b></span><br>`;

  // Base chart options (if additional charts come back
  // in the future like the pie chart, these can be used)
  Highcharts.setOptions({
    lang: {
      thousandsSep: ',',
    },
    credits: {
      enabled: true,
    },
    chart: {
      type: 'area',
      height: '600',
    },
    yAxis: {
      title: {
        text: 'Charging Ports',
      },
    },
    xAxis: {
      type: 'datetime',
    },
    tooltip: {
      shared: true,
      headerFormat: '<span style="font-size:0.75rem;"><strong>{point.key}</strong></span><br>',
    },
    plotOptions: {
      area: {
        stacking: 'overlap',
      },
      series: {
        marker: {
          enabled: false,
        },
        events: {
          legendItemClick() {
            return false;
          },
        },
      },
    },
    legend: {
      itemStyle: {
        cursor: 'default',
      },
    },
  });

  const container = wrapper.querySelector('#container-stations-growth');

  // create the chart
  const chart = Highcharts.chart(container, {
    title: {
      text: chartData.chartTitle,
    },
    tooltip: {
      xDateFormat: '%B %Y',
      footerFormat: toolTipTotal,
    },
    series: [],
  });

  // Handle checkbox changes
  // charger type fields:
  const level2Box = document.getElementById('level_2');
  const dcBox = document.getElementById('dc_fast');

  // station status fields:
  const availableBox = document.getElementById('available');
  const tempUnavailableBox = document.getElementById('temporarily_unavailable');

  // when no filters are selected:
  const noDataContainer = document.getElementById('container-no-data');
  const noFiltersSelected = (!availableBox.checked && !tempUnavailableBox.checked)
    || (!level2Box.checked && !dcBox.checked);

  if (noFiltersSelected) {
    container.hidden = true;
    noDataContainer.hidden = false;
  } else {
    container.hidden = false;
    noDataContainer.hidden = true;
  }

  function addSeriesToChart(name, color, data) {
    chart.addSeries({
      name,
      color,
      data,
      legendSymbol: 'rectangle',
    });
  }

  if (availableBox.checked && level2Box.checked) {
    addSeriesToChart(chartData.seriesLabelL2Available, '#00B5EF', level2AvailableDataset);
  }
  if (availableBox.checked && dcBox.checked) {
    addSeriesToChart(chartData.seriesLabelDcAvailable, '#005A7C', dcAvailableDataset);
  }
  if (tempUnavailableBox.checked && level2Box.checked) {
    addSeriesToChart(chartData.seriesLabelL2TmpUnavailable, '#9D9D9D', l2TempUnavailableDataset);
  }
  if (tempUnavailableBox.checked && dcBox.checked) {
    addSeriesToChart(chartData.seriesLabelDcTmpUnavailable, '#666666', dcTempUnavailableDataset);
  }

  return () => {
    const existing = Highcharts.charts.find((c) => c && c.renderTo === container);
    if (existing) existing.destroy();
  };
});
